import MediaCaptureField from "./MediaCaptureField.js"

/**
 * Status-screen photo card. The shared picker shows one small preview.
 */
const CapturePhotoField = ({
  label,
  required = false,
  file = null,
  onPick,
  onClear,
  disabled = false,
}) => {
  return (
    <div className="min-w-0 rounded-xl border border-gray-200 bg-white p-3">
      <p className="text-sm font-semibold text-blue-900 mb-2">
        {label} {required ? <span className="text-red-500">*</span> : null}
      </p>
      <MediaCaptureField
        mode="photo"
        disabled={disabled}
        onPick={onPick}
        onClear={onClear}
        selectedFile={file}
      />
      <p className="text-[10px] sm:text-xs text-gray-500 text-center mt-2">
        Take a photo with the camera, or upload from gallery.
      </p>
    </div>
  )
}

export default CapturePhotoField
